export const degreeToRadian = (degree: number): number => {
  return (degree * Math.PI) / 180;
};

export const displacementBetween = (
  start: {
    lat: number;
    lon: number;
  },
  end: {
    lat: number;
    lon: number;
  }
): number => {
  const earthRadiusInM = 6371000;

  const latDistance = degreeToRadian(end.lat - start.lat);
  const lonDistance = degreeToRadian(end.lon - start.lon);

  const latOrigin = degreeToRadian(start.lat);
  const latDestination = degreeToRadian(end.lat);

  const a =
    Math.sin(latDistance / 2) * Math.sin(latDistance / 2) +
    Math.sin(lonDistance / 2) *
      Math.sin(lonDistance / 2) *
      Math.cos(latOrigin) *
      Math.cos(latDestination);

  const dist = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return Math.floor(earthRadiusInM * dist);
};
